import React, { useEffect, useRef, useState } from "react";
import AdminLayout from "./AdminLayout";
import "../Admin/admin.css";
import { endpoints } from "../_config";
import { get, post } from "../_services/apiService";
import { toast } from "react-toastify";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import ProductTemplate from "./producttemplate";
import ClipLoader from "react-spinners/ClipLoader";

const QuotationList = () => {
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(5);
    const [quatationData, setQuatationData] = useState();
    const [quatationItemData, setQuatationItemData] = useState();
    const [productOrderData, setproductOrderData] = useState();
    const [appointmentId, setAppointment] = useState('0');
    // const [status, setStatus] = useState('1');
    const pdfRef = useRef();
    const [price, setPrice] = useState("");
    const [isPriceAdded, setIsPriceAdded] = useState(false);

    const handleAddPrice = () => {
        if (!price) return;
        setIsPriceAdded(true);
    };

    const resetPriceState = () => {
        setPrice("");
        setIsPriceAdded(false);
    };

    const GetQuatation = async () => {
        try {
            const response = await get(endpoints.GetQuatation);
            if (response.isSuccess === 200) {
                const sortedData = [...response.data].sort((a, b) =>
                    new Date(b.createdDate) - new Date(a.createdDate) // newest first
                );
                setQuatationData(sortedData);
            } else {
                setQuatationData(null);
            }
        } catch (error) {
            setQuatationData(null);
        }
    };

    useEffect(() => {
        GetQuatation();
    }, []);

    const data = [
        {
            id: 1,
            image: "https://imageio.forbes.com/specials-images/imageserve/5d35eacaf1176b0008974b54/0x0.jpg?format=jpg&crop=4560,2565,x790,y784,safe&height=900&width=1600&fit=bounds",
            code: "#22323",
            name: "Car",
            displayName: "Car",
            description: "Here Are The Coolest New Cars For 2020",
            isDisplay: true,
            isActive: true,
        },
        {
            id: 2,
            image: "https://imageio.forbes.com/specials-images/imageserve/5d35eacaf1176b0008974b54/0x0.jpg?format=jpg&crop=4560,2565,x790,y784,safe&height=900&width=1600&fit=bounds",
            code: "#22323",
            name: "Bike",
            displayName: "Bike",
            description: "New Bikes Launch in 2020",
            isDisplay: true,
            isActive: false,
        },
        // Add more mock data
    ];

    const totalPages = Math.ceil(data.length / itemsPerPage);

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const modelToggle = (modelname, status, item) => {
        // Get the modal element by ID

        setQuatationItemData(item);
        const modalElement = document.getElementById(modelname);
        let modal = window.bootstrap.Modal.getInstance(modalElement);
        if (!modal) {
            modal = new window.bootstrap.Modal(modalElement);
        }
        // Show or hide the modal based on the status value
        if (status) {
            modal.show(); // Show the modal if status is true
        } else {
            modal.hide(); // Hide the modal if status is false
        }
    };


    const modelToggleData = (modelname, status, item) => {
        const modalElement = document.getElementById(modelname);
        let modal = window.bootstrap.Modal.getInstance(modalElement);

        if (!modal) {
            modal = new window.bootstrap.Modal(modalElement);
        }
        // Show or hide the modal based on the status value
        if (status) {
            setproductOrderData(item);
            setAppointment(item.quotationId);
            resetPriceState();

            modal.show(); // Show the modal if status is true
        } else {
            modal.hide(); // Hide the modal if status is false
            resetPriceState();
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const element = pdfRef.current;
        const canvas = await html2canvas(element, { scale: 2 });

        // Ensure the canvas is properly generated
        if (!canvas) {
            toast.error("Failed to capture the content.");
            return;
        }

        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");

        const pdfWidth = pdf.internal.pageSize.getWidth();
        let pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        // Optionally, ensure you're not cutting off content if it's too large
        const maxHeight = pdf.internal.pageSize.getHeight();
        if (pdfHeight > maxHeight) {
            pdfHeight = maxHeight;
        }

        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

        // Generate PDF Blob
        const pdfBlob = pdf.output("blob");

        try {
            const formDataToSend = new FormData();
            formDataToSend.append("file", pdfBlob);
            formDataToSend.append("pQuatationId", appointmentId);
            formDataToSend.append("pStatus", 1);
            // const response = await get(endpoints.UpdateStatusQuatationById + "?pQuatationId=" + appointmentId + "&pStatus=" + status);
            const response = await post(endpoints.UpdateStatusQuatationById, formDataToSend);

            if (response.isSuccess === 200) {

                toast.success("Status Update successfully");
                GetQuatation();

                modelToggleData('modeldatastatus', false, null);

            } else {
                toast.error(response.message);
            }
        } catch (error) {
            toast.error("Please try again later.");
        } finally {
            setLoading(false);
            resetPriceState();
            setLoading(false)
        }
    };


    return (
        <div className="admin_qoutation_model_shadow">
            <AdminLayout>
                <div className="product_wepper">
                    <div className="container-fluid">

                        {/* Table Section */}
                        <div className="row mt-3 product_hedding_table_main">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th style={{ minWidth: "150px" }}>Name</th>
                                        <th style={{ minWidth: "250px" }}>Email Id</th>
                                        <th>Contact No</th>
                                        <th style={{ minWidth: "200px" }}>Address</th>
                                        <th style={{ minWidth: "200px" }}>Service Type</th>
                                        <th style={{ minWidth: "150px" }}>Size</th>
                                        <th style={{ minWidth: "150px" }}>Entry Date</th>
                                        <th>Status</th>
                                        <th>View</th>
                                        <th>Action</th>
                                    </tr>


                                </thead>
                                <tbody>
                                    {quatationData?.length > 0 ? (
                                        quatationData?.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>

                                                <td>{item.firstName} {item.lastName}</td>
                                                <td>{item.emailId}</td>
                                                <td>{item.contactNo}</td>
                                                <td>{item.address} </td>
                                                <td style={{ minWidth: "150px" }}>{item.serviceName}</td>
                                                <td style={{ minWidth: "120px" }}>{item.sizeTypeName}</td>
                                                <td style={{ minWidth: "150px" }}>{item.createdDate}</td>
                                                <td>{item.status}</td>
                                                <td>
                                                    <span className="edit_icon_wepper" onClick={() => modelToggle('modeldata', true, item)} >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 32 32" fill="none">
                                                            <path d="M16 9.75C12.5537 9.75 9.75 12.5538 9.75 16C9.75 19.4462 12.5537 22.25 16 22.25C19.4463 22.25 22.25 19.4462 22.25 16C22.25 12.5538 19.4463 9.75 16 9.75ZM16 19.75C13.9323 19.75 12.25 18.0677 12.25 16C12.25 13.9323 13.9323 12.25 16 12.25C18.0677 12.25 19.75 13.9323 19.75 16C19.75 18.0677 18.0677 19.75 16 19.75Z" fill="black" />
                                                            <path d="M31.5881 15.3389C30.3622 13.3717 24.1243 4.75 16 4.75C7.8775 4.75 1.63787 13.3716 0.411938 15.3389L0 16L0.411938 16.6611C1.63775 18.6283 7.87569 27.25 16 27.25C24.1225 27.25 30.3621 18.6284 31.5881 16.6611L32 16L31.5881 15.3389ZM16 24.75C9.69775 24.75 4.50862 18.1404 2.99325 15.999C4.50581 13.8559 9.68162 7.25 16 7.25C22.3018 7.25 27.4907 13.8587 29.0068 16.001C27.4942 18.1442 22.3184 24.75 16 24.75Z" fill="black" />
                                                        </svg>
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="action_btn_weepr">
                                                        <span className="edit_icon_wepper" onClick={() => modelToggleData('modeldatastatus', true, item)} >
                                                            <svg id="Layer_1" viewBox="0 0 512 512" width="15" height="15" xmlns="http://www.w3.org/2000/svg">
                                                                <g transform="matrix(1,0,0,1,0,0)">
                                                                    <path
                                                                        d="m41.3 512c-22.8 0-41.3-18.5-41.3-41.3 0-2.6.2-5.2.7-7.7l27.3-144.8c1.5-8.2 5.5-15.7 11.4-21.5l274-274c14.7-14.7 35.1-22.7 57.7-22.7 8.1 0 16.1 1 24 2.8 25.5 5.9 51.1 20.7 72.2 41.8s36 46.7 41.8 72.2c7.4 31.9.2 61.7-19.8 81.7l-274 274c-5.9 5.9-13.4 9.8-21.5 11.4l-144.8 27.4c-2.5.5-5.1.7-7.7.7zm51.8-93.1 72.9-13.8 182-182-59.1-59.1-182 182zm313.3-254.2 23.1-23.1c.2-5.4-3.8-21.8-20.6-38.5-10.1-10.2-22-17.4-32.4-19.8-1.8-.4-3.7-.7-5.5-.7h-.7l-23 23z"
                                                                        fill="#000"
                                                                    ></path>
                                                                    <path
                                                                        d="m499.4 119.1c-5.4-23.7-19.4-47.6-39.1-67.4s-43.8-33.7-67.4-39.1c-28.5-6.6-54.9-.4-72.3 17.1l-274 274c-4.5 4.4-7.5 10.1-8.7 16.3l-27.4 144.9c-3.2 17 8 33.4 24.9 36.6 1.9.4 3.9.5 5.8.5s3.9-.2 5.8-.5l145-27.4c6.2-1.2 11.9-4.2 16.3-8.6l274-274c17.5-17.5 23.7-43.9 17.1-72.4zm-328.5 295.3-90.3 17 17-90.3 191.3-191.3 73.3 73.3zm267.2-267.2-31.7 31.7-73.2-73.3 31.7-31.7c1-1 5.6-2.3 14-.4 12.2 2.8 25.8 11 37.2 22.4 23.5 23.7 25.6 47.7 22 51.3z"
                                                                        fill="url(#gradient1)"
                                                                    ></path>
                                                                    <defs>
                                                                        <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                                                            <stop offset="0%" stop-color="#000"></stop>
                                                                            <stop offset="100%" stop-color="#000"></stop>
                                                                        </linearGradient>
                                                                    </defs>
                                                                </g>
                                                            </svg>
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                No results found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            {/* Pagination */}
                            <nav aria-label="...">
                                <ul className="pagination justify-content-end">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button className="page-link" onClick={handlePrevPage}>
                                            Previous
                                        </button>
                                    </li>
                                    {Array.from({ length: totalPages }, (_, index) => (
                                        <li
                                            key={index}
                                            className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(index + 1)}
                                            >
                                                {index + 1}
                                            </button>
                                        </li>
                                    ))}
                                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                        <button className="page-link" onClick={handleNextPage}>
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </AdminLayout>
            {/* Modal */}
            <div className="modal fade" id="modeldata" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content" style={{ border: "none", overflow: "hidden" }}>
                        <div className="modal-header model_header_bg">
                            <h5 className="modal-title" id="exampleModalLabel" style={{ color: "#ffffff" }}>Quotation</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">

                            {quatationItemData != null ?
                                <div className="">

                                    <div className="quotation-details row">
                                        <div className="col-sm-6">
                                            <div className="quotation-details-box">
                                                <div className="row">
                                                    <div className="col-md-6" style={{ color: "#3C3C3C" }}><strong>Name :</strong></div>
                                                    <div className="col-md-6" style={{ color: "#626262" }}>{quatationItemData?.firstName} {quatationItemData?.lastName}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6" style={{ color: "#3C3C3C" }}><strong>Contact No :</strong></div>
                                                    <div className="col-md-6" style={{ color: "#626262" }}>{quatationItemData?.contactNo}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6" style={{ color: "#3C3C3C" }}><strong>Service Type :</strong></div>
                                                    <div className="col-md-6" style={{ color: "#626262" }}>{quatationItemData?.serviceName}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6" style={{ color: "#3C3C3C" }}><strong>Product Detail :</strong></div>
                                                    <div className="col-md-6" style={{ color: "#626262" }}>{quatationItemData?.productDetail}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6" style={{ color: "#3C3C3C" }}><strong>Additional Message :</strong></div>
                                                    <div className="col-md-6" style={{ color: "#626262" }}>{quatationItemData?.additionalMsg}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="quotation-details-box">
                                                <div className="row">
                                                    <div className="col-md-6" style={{ color: "#3C3C3C" }}><strong>Email Id :</strong></div>
                                                    <div className="col-md-6" style={{ color: "#626262" }}>{quatationItemData?.emailId}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6" style={{ color: "#3C3C3C" }}><strong>Address :</strong></div>
                                                    <div className="col-md-6" style={{ color: "#626262" }}>{quatationItemData?.address}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6" style={{ color: "#3C3C3C" }}><strong>Size Type Name :</strong></div>
                                                    <div className="col-md-6" style={{ color: "#626262" }}>{quatationItemData?.sizeTypeName}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6" style={{ color: "#3C3C3C" }}><strong>Referral Source :</strong></div>
                                                    <div className="col-md-6" style={{ color: "#626262" }}>{quatationItemData?.referralSource}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="quotation-details d-flex gap-4 pt-0">
                                        {quatationItemData?.productPath && (
                                            <div className="">
                                                <p className="mb-2"><strong>Product Image:</strong></p>
                                                <div>
                                                    <img
                                                        src={`${quatationItemData?.productPath}`}
                                                        alt="Product"
                                                        className="quotation-img"
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {quatationItemData?.serialImagePath && (
                                            <div className="">
                                                <p className="mb-2"><strong>Serial Image:</strong></p>
                                                <div>
                                                    <img
                                                        src={`${quatationItemData?.serialImagePath}`}
                                                        alt="Serial"
                                                        className="quotation-img"
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                : null}
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div className="modal fade" id="modeldatastatus" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Product</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <form onSubmit={handleSubmit}>
                                <div className="modal-body">
                                    <div>
                                        <div ref={pdfRef} style={{ padding: 20 }}>
                                            <ProductTemplate
                                                productOrderData={productOrderData}
                                                isPriceAdded={isPriceAdded}
                                                setPrice={setPrice}
                                                handleAddPrice={handleAddPrice}
                                                price={price}
                                            />
                                        </div>
                                    </div>
                                    <div className="modal-footer justify-content-center">
                                        <button
                                            type="submit"
                                            className="all_sumbit_button"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <ClipLoader
                                                    size={20}
                                                    color="#ffffff"
                                                    loading={loading}
                                                />
                                            ) : (
                                                "Submit"
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuotationList;
